import { lazy } from 'react';
import { RoleBasedGuard } from 'src/auth/guard';
import { ROLES } from 'src/constants';

// ----------------------------------------------------------------------

const HomeEdProgramPlanListPage = lazy(() => import('src/pages/home-ed-program-plan/list'));
const HomeEdProgramPlanAdminEditPage = lazy(() => import('src/pages/home-ed-program-plan/edit'));
const HomeEdProgramPlanStartPage = lazy(() => import('src/pages/home-ed-program-plan/start'));
const HomeEdProgramPlanFormPage = lazy(() => import('src/pages/home-ed-program-plan/form'));
const HomeEdProgramPlanConfirmationPage = lazy(
  () => import('src/pages/home-ed-program-plan/confirmation')
);

// ----------------------------------------------------------------------

const guardedListPage = (
  <RoleBasedGuard navigateTo roles={[ROLES.HOMESCHOOL_FACILITATOR, ROLES.HOMESCHOOL_ADMIN]}>
    <HomeEdProgramPlanListPage />
  </RoleBasedGuard>
);

const guardedAdminEditPage = (
  <RoleBasedGuard navigateTo roles={[ROLES.HOMESCHOOL_FACILITATOR, ROLES.HOMESCHOOL_ADMIN]}>
    <HomeEdProgramPlanAdminEditPage />
  </RoleBasedGuard>
);

const guardedFormPage = (
  <RoleBasedGuard navigateTo roles={['User.User']}>
    <HomeEdProgramPlanFormPage />
  </RoleBasedGuard>
);

const guardedStartPage = (
  <RoleBasedGuard navigateTo roles={['User.User']}>
    <HomeEdProgramPlanStartPage />
  </RoleBasedGuard>
);

const guardedConfirmation = (
  <RoleBasedGuard navigateTo roles={['User.User']}>
    <HomeEdProgramPlanConfirmationPage />
  </RoleBasedGuard>
);

export const homeEdProgramPlanRoutes = [
  {
    path: 'home-ed-program-plan',
    children: [
      { element: guardedListPage, index: true },
      {
        path: ':planId',
        children: [
          { element: guardedAdminEditPage, index: true },
          { path: 'start', element: guardedStartPage },
          { path: 'form', element: guardedFormPage },
          { path: 'confirmation', element: guardedConfirmation },
        ],
      },
    ],
  },
];
